document.addEventListener('DOMContentLoaded', () => {
    const header = document.getElementById('header');
    const banner = document.getElementById('banner');

    // --- Логика скролла и классов ---
    if (header && banner) {
        let lastScrollTop = 0;
        let scrollingDown = true;

        const isBannerHalfVisible = (): boolean => {
            const bannerRect = banner.getBoundingClientRect();
            const bannerHeight = bannerRect.height;
            // Проверяем, видно ли более 50% баннера
            return bannerRect.bottom > bannerHeight / 2;
        };

        const handleScroll = () => {
            const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            // Определяем направление скролла
            scrollingDown = currentScrollTop > lastScrollTop;
            // Проверяем видимость баннера
            const bannerHalfVisible = isBannerHalfVisible();
            // Если более 50% баннера не видно - добавляем класс scrolled
            if (!bannerHalfVisible) {
                header.classList.add('scrolled');
                // Если скроллим вниз - добавляем класс hidden
                if (scrollingDown) {
                    header.classList.add('hidden');
                } else {
                    // Если скроллим вверх - убираем класс hidden
                    header.classList.remove('hidden');
                }
            } else {
                // Если более 50% баннера видно - убираем класс scrolled
                header.classList.remove('scrolled');
                // Если скроллим вверх - убираем класс hidden
                if (!scrollingDown) {
                    header.classList.remove('hidden');
                }
            }
            lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
        };

        // Обработка начального состояния
        handleScroll();
        // Добавляем обработчик события при скролле
        window.addEventListener('scroll', handleScroll, { passive: true });
    }

    // --- Мобильное меню ---
    const mobHead = document.querySelector('.header__mobHead');
    const burger = document.querySelector('.header__burger');
    const mobHeadClose = document.querySelector('.mobHead-close');
    if (burger && mobHead) {
        burger.addEventListener('click', () => {
            mobHead.classList.add('active');
        });
    }
    if (mobHeadClose && mobHead) {
        mobHeadClose.addEventListener('click', () => {
            mobHead.classList.remove('active');
        });
    }
    if (mobHead) {
        const mobCallbackBtn = mobHead.querySelector('button[data-action="callback-modal"]');
        if (mobCallbackBtn) {
            mobCallbackBtn.addEventListener('click', () => {
                mobHead.classList.remove('active');
            });
        }
    }
});
